export default "__VITE_ASSET__46c4b813__"